module.exports = __webpack_public_path__ + "static/img/pexels-lisa-fotios-16129877@2x.375ef4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/pexels-lisa-fotios-16129877@2x.png
// module id = KVR0
// module chunks = 0